import {
  ProfileDetailsGameplayRoot,
  type ProfileDetailsGameplayRootProps,
} from './gameplayRoot';
import {
  ProfileDetailsGameplayHeader,
  type ProfileDetailsGameplayHeaderProps,
} from './header';
import {
  ProfileDetailsGameplayLastPlayed,
  type ProfileDetailsGameplayLastPlayedProps,
} from './lastPlayed';
import {
  ProfileDetailsGameplayMostPlayedAgents,
  type ProfileDetailsGameplayMostPlayedAgentsProps,
} from './mostPlayedAgents';
import { ProfileDetailsGameplayNametag } from './nametag';
import {
  ProfileDetailsGameplayPlayerInfo,
  type ProfileDetailsGameplayPlayerInfoProps,
} from './playerInfo';
import {
  ProfileDetailsGameplayRank,
  type ProfileDetailsGameplayRankProps,
} from './rank';
import {
  ProfileDetailsGameplaySkillOverview,
  type ProfileDetailsGameplaySkillOverviewProps,
} from './skillOverview';
import {
  ProfileDetailsGameplaySocialOverview,
  type ProfileDetailsGameplaySocialOverviewProps,
} from './socialOverview';

export const ProfileDetailsGameplay = {
  Root: ProfileDetailsGameplayRoot,
  Header: ProfileDetailsGameplayHeader,
  Nametag: ProfileDetailsGameplayNametag,
  PlayerInfo: ProfileDetailsGameplayPlayerInfo,
  Rank: ProfileDetailsGameplayRank,
  MostPlayedAgents: ProfileDetailsGameplayMostPlayedAgents,
  SkillOverview: ProfileDetailsGameplaySkillOverview,
  SocialOverview: ProfileDetailsGameplaySocialOverview,
  LastPlayed: ProfileDetailsGameplayLastPlayed,
} as const;

export type {
  ProfileDetailsGameplayHeaderProps,
  ProfileDetailsGameplayLastPlayedProps,
  ProfileDetailsGameplayMostPlayedAgentsProps,
  ProfileDetailsGameplayPlayerInfoProps,
  ProfileDetailsGameplayRankProps,
  ProfileDetailsGameplayRootProps,
  ProfileDetailsGameplaySkillOverviewProps,
  ProfileDetailsGameplaySocialOverviewProps,
};
